module.exports = __webpack_public_path__ + "img/jpg.b732a906.svg";